// import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

function* applicationSaga() {}

export default applicationSaga;
